<template>
  <div class="step-2">
    <PreBookedOffers v-if="getPrebookedOffers.length"
                     :offers="getPrebookedOffers"
                     :is-active-step="actualStep === step"
                     :is-individual="isIndividual" />
    <p>
      {{ getStepText('firstParagraphe') }}
    </p>
    <div v-if="isMinarm" class="step-2__panel">
      <div class="step-2__panel__heading">
        <h4 class="step-2__panel__heading__title">
          <font-awesome-icon icon="angle-down"/>
          {{ $t('procedures.minarmSteps.second.panel.title') }}
        </h4>
      </div>

      <div class="step-2__panel__body">
        <ol>
          <li class="step-2__panel__body__list">
            {{ $t('procedures.minarmSteps.second.panel.firstParagraphe') }}
            <p>
              <el-link :href="downloadOfferUrl"
                    :underline="false"
                    class="button-link"
                    target="_blank">
              {{ $t('procedures.minarmSteps.second.panel.downloadQuote') }}
              </el-link>
            </p>
          </li>
          <li class="step-2__panel__body__list">
            {{ $t('procedures.minarmSteps.second.panel.secondParagraphe') }}
            <p>
              <el-link :href="$t('procedures.minarmSteps.second.panel.cguLink')"
                    :underline="false"
                    class="button-link"
                    target="_blank">
              {{ $t('procedures.minarmSteps.second.panel.downloadCgu') }}
              </el-link>
            </p>
          </li>
          <li class="step-2__panel__body__list">
            {{ $t('procedures.minarmSteps.second.panel.thirdParagraphe.before') }}
            <el-link
              type="primary"
              class="step-2__panel__body__cgu"
              :href="$t('procedures.minarmSteps.second.panel.cguLink')"
              _target="blank">
              {{ $t('procedures.minarmSteps.second.panel.thirdParagraphe.linkText') }}
            </el-link>
            {{ $t(
              'procedures.minarmSteps.second.panel.thirdParagraphe.after',
              { numClient: demandStore.num_client },
            ) }}
            <p class="step-2__panel__body__action">
              <el-link :href="createMyFileLinkOnline"
                      :underline="false"
                      class="step-2__panel__body__action__link button-link"
                      target="_blank">
                {{ $t('procedures.minarmSteps.second.panel.createMyFileOnline') }}
              </el-link>
              <el-link :href="createMyFileLink"
                      :underline="false"
                      class="step-2__panel__body__action__link button-link"
                      target="_blank">
                {{ $t('procedures.minarmSteps.second.panel.createMyFile') }}
              </el-link>
            </p>
          </li>
          <li class="step-2__panel__body__list"
              v-html="$t('procedures.minarmSteps.second.panel.fourthParagraphe',
              { nbDays: nbDaysBookingLimit })">
          </li>
        </ol>
      </div>
    </div>
  </div>
</template>

<script>
import StepWrapper from '@/components/procedures/prebookStepper/steps/StepWrapper.vue';
import demandHelper from '@/utils/helpers/demand';
import offersHelper from '@/utils/helpers/offers';

export default {
  name: 'step2',
  extends: StepWrapper,
  computed: {
    createMyFileLink() {
      if (demandHelper.isInternational(this.demandStore)) {
        return this.$t('procedures.minarmSteps.second.panel.createMyFileLinkInter');
      }
      return this.$t('procedures.minarmSteps.second.panel.createMyFileLink');
    },
    createMyFileLinkOnline() {
      if (demandHelper.isInternational(this.demandStore)) {
        return this.$t('procedures.minarmSteps.second.panel.createMyFileLinkOnlineInter');
      }
      return this.$t('procedures.minarmSteps.second.panel.createMyFileLinkOnline');
    },
    downloadOfferUrl() {
      const offer = this.getPrebookedOffers;
      return offer && offer[0] && offer[0].url;
    },
    getNotInitialPrebookedOffers() {
      return offersHelper.getNotInitialPrebookedOffers(this.offersStore);
    },
    getPrebookedOffers() {
      return (this.prebookedOffers.length && this.prebookedOffers)
        || (this.actualStep !== this.step && this.getNotInitialPrebookedOffers)
        || '';
    },
  },
};
</script>

<style lang="scss" scoped>
.step-2 {
  &__panel {
    box-shadow: 0 1px 2px rgba(0,0,0,.05);
    background-color: $--color-light-grey;
    border-radius: 4px;
    margin-top: 20px;
    &__heading {
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
      background-color: $--color-light-blue-grey;
      padding: 5px 10px;
      &__title {
        margin: 0;
      }
    }
    &__body {
      padding: 0 20px 10px;
      &__list {
        margin-bottom: 1em;
        font-size: 15px;
      }
      &__cgu {
        font-size: 15px;
        display: inline;
        vertical-align: baseline;
      }
      &__action {
        text-align: center;
        &__link {
          margin: 5px 5px 20px 5px;
        }
      }
      ol {
        padding-left: 20px;
      }
    }
  }
}
</style>
